// extracted by mini-css-extract-plugin
export default {"tooltip":"EXOSL3x","label":"ytHW66n","text":"D9SK6il"};